import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { PaginatorComponent } from '@app/shared/components/data-table/paginator/paginator.component';

@Component({
  selector: 'app-infiniscroll-paginator',
  templateUrl: './infiniscroll-paginator.component.html',
  styleUrls: ['./infiniscroll-paginator.component.scss'],
  // TODO(onpush): extends PaginatorComponent, whose public fields are mutated directly via
  // @ViewChild references from sibling data-source classes outside this migration's scope. See
  // paginator.component.ts for details. Keeping Eager.
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InfiniscrollPaginatorComponent extends PaginatorComponent {
  @Input() detailTemplate?: TemplateRef<any>;
  Math = Math;
}
